import {AfterViewChecked, Component, ElementRef, EventEmitter, Input, Output, ViewChild} from '@angular/core';
import {FormsModule} from "@angular/forms";
import {Router} from "@angular/router";
import { KeyValuePipe, NgClass } from "@angular/common";
import {Observable, of} from "rxjs";
import {catchError, map} from "rxjs/operators";
import {HttpClient, HttpHeaders} from "@angular/common/http";
import {ApiUrl} from "../../../shared/models/apiurl.models";
import {TranslateModule} from "@ngx-translate/core";

@Component({
    selector: 'app-search-popup',
    templateUrl: './search-popup.component.html',
    imports: [
    FormsModule,
    KeyValuePipe,
    NgClass,
    TranslateModule
],
    styleUrls: ['./search-popup.component.scss']
})
export class SearchPopupComponent implements AfterViewChecked {
  private options = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json',
      'Authorization': this.apiKey.getJWTToken()
    })
  }

  @ViewChild('searchInput') searchInputRef!: ElementRef<HTMLInputElement>;

  @Input() isPopupOpen = false;
  @Output() isPopupOpenChange = new EventEmitter<boolean>();
  searchText = '';

  constructor(private http: HttpClient, private apiKey:ApiUrl, private router: Router) {}


  scrollToInput() {
    if (this.searchInputRef && this.searchInputRef.nativeElement) {
      setTimeout(() => {
        this.searchInputRef.nativeElement.scrollIntoView({
          behavior: 'smooth',
          block: 'center'
        });
      }, 300); // Delay for keyboard animation
    }
  }

  ngAfterViewChecked(): void {
    if (this.isPopupOpen && this.searchInputRef) {
      this.searchInputRef.nativeElement.focus();
    }
  }
  inProgress = false;
  searchValue: string = '';
  searchProductList: Record<string, any[]> = {
    car: [],
    nadlan: [],
    sale2: []
  };

  onBrowserSearch(event: any): void {
    const query = event.target.value;
    this.searchValue = query;
    this.inProgress = true;
    this.browserSearch(query).subscribe(res => {
      this.inProgress = false;
      ['car', 'nadlan', 'sale2'].forEach(index => {
        this.searchProductList[index] = [];
        if (res && res[index]) {
          this.searchProductList[index].push(...res[index]);
        }
      });
    });
  }

  getCategoryDesc(category: string): string {
    switch (category.toLowerCase()) {
      case 'car': return "sale4you.label.cars";
      case 'sale2': return "sale4you.label.sale2";
      case 'nadlan': return "sale4you.label.nadlans";
      default: return 'gray';
    }
  }
  onclick($event:any, item: any){

    this.closePopup()
    this.router.navigateByUrl('/', { skipLocationChange: true }).then(() => {
      this.router.navigate([`/single/${item.id}`]);
    });
  }

  isSearchEmpty(): boolean {
    if (!this.searchProductList) return true;
    const values = Object.values(this.searchProductList);
    return values.every(arr => arr.length === 0);
  }

  getStatusColor(status: string): string {
    switch (status) {
      case 'online': return 'green';
      case 'offline': return 'gray';
      case 'busy': return 'red';
      default: return 'gray';
    }
  }

  browserSearch(query: string): Observable<any> {
    return this.http
        .get(this.apiKey.getBrowserSearch(query), this.options)
        .pipe(
            map(res => (res ? res : null)),
            catchError(err => this.handleObserverError(err))
        );
  }

  private handleObserverError(error: any): Observable<null> {
    console.error('Search error:', error);
    return of(null);
  }

  onSearch(query: string) {
    // Simulate a search filter
    console.log('Search query:', query);
    // You can filter searchResults here based on `query`
  }

  closePopup() {
    this.isPopupOpen = false;
    this.isPopupOpenChange.emit(this.isPopupOpen);
  }
}
